import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ConfirmRedirectDialogData } from '../confirm-redirect-popup/confirm-redirect-popup.component';
import { SubEditClaimchartPopupComponent } from './sub-edit-dialog.component';


@Component({
  selector: 'app-edit-claimchart-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinner, FormsModule, MatIconModule],
  templateUrl: './edit-claimchart-popup.component.html',
  styleUrls: ['./edit-claimchart-popup.component.css'],
})
export class EditClaimchartPopupComponent {
    editableClaimData: any[] = [];
    isExpanded: { claim: boolean; infringement: boolean }[] = [];
    claimChartTitle: string = 'Edit Claim Chart';
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<EditClaimchartPopupComponent>,
      public dialog: MatDialog
    ) {}
  
    ngOnInit(): void {
        console.log(this.data)
        this.claimChartTitle=this.data.claimData.patent_number+' vs '+this.data.claimData.targeted_product;
        this.editableClaimData = this.data.claimData.data.map((item: any) => ({
            ...item,
            references: (item.references || []).map((ref: any) => ({
              reference: ref.reference || ref.text || '',
              source: ref.source || ref.url || ''
            }))
          })).sort((a: any, b: any) => a.orderKey - b.orderKey);
        this.isExpanded = this.editableClaimData.map(() => ({ claim: false, infringement: false }));
        }
    generateInfringementHTML(claimElement: any): string {
        let html = `<div class="claim-item-iterable type-analyst"><b>Analyst Comment:</b> ${claimElement.analyst_comment || ''}</div>`;

        if (claimElement.references?.length) {
            html += `<div class="claim-item-iterable type-references"><b>References:</b></div><ul class="type-ul">`;
            for (const ref of claimElement.references) {
                html += `<li class="claim-item-iterable type-reference ">${ref.reference}</li><li class="claim-item-iterable type-reference type-source2 ">${ref.source}</li>`;
            }
            // html += `</ul><div class="claim-item-iterable type-sources"><b>Sources:</b></div><ul class="type-ul">`;
            // for (const ref of claimElement.references) {
            //     html += `<li class="claim-item-iterable type-source">${ref.source}</li>`;
            // }
            html += `</ul>`;
        }

        return html;
    }

    handleInfringementBlur(event: any, index: number) {
        const container = event.target as HTMLElement;
        const children = Array.from(container.children) as HTMLElement[];

        let analyst_comment = '';
        const references: { reference: string; source: string }[] = [];
        let readingRefs = false;
        let readingSources = false;
        let sourcesIndex= 0;

        let childrenCandidate=[]

        for (const child of children) {
            if (child.classList.contains('type-analyst') || child.classList.contains('type-references') || child.classList.contains('type-sources')) {
                childrenCandidate.push(child);
            }
            else if(child.classList.contains('type-ul')) {
                childrenCandidate.push(...Array.from(child.children) as HTMLElement[]);
            }
        }

        console.log('childrenCandidate', childrenCandidate);
        

        for (const child of childrenCandidate) {
            const text = child.innerText.trim()
                .replace(/^Analyst Comment:\s*/, '')
                .replace(/^References:\s*/, '')
                .replace(/^Sources:\s*/, '');
            // if(text=='') continue; // skip empty lines

            console.log('child', child.classList, text);

            if (child.classList.contains('type-analyst')) {
                analyst_comment+= text+'\n';
            }
            else if (child.classList.contains('type-references')) {
                readingRefs = true;
                readingSources = false;
            }
            else if (child.classList.contains('type-reference') && readingRefs) {
              console.log(sourcesIndex, text)
              if(sourcesIndex%2 === 0) {
                // This is a reference
                references.push({ reference: text, source: '' });
                sourcesIndex++;
              }
              else {
             references[references.length-1].source = text;
                sourcesIndex++;
              }

              }
            // }
            // else if (child.classList.contains('type-sources')) {
            //     readingRefs = false;
            //     readingSources = true;
            // }
            // else if (child.classList.contains('type-source') && readingSources && references.length) {
            //     console.log(sourcesIndex, text)
            //     if(sourcesIndex >= references.length) {
            //         console.warn('More sources than references, skipping:', text);
            //         continue;
            //     }
            //     references[sourcesIndex++].source = text;
            // }
        }
        this.editableClaimData[index].analyst_comment = analyst_comment;
        this.editableClaimData[index].references = references;
        console.log('updated data: ', this.editableClaimData[index]);
    }
        toggleExpand(index: number, field: 'claim' | 'infringement') {
            // this.isExpanded[index][field] = !this.isExpanded[index][field];
            // open SubEditClaimchartPopupComponent and send the htmldata of the claim element
            const claimElement = this.editableClaimData[index];
            const htmlData = this.generateInfringementHTML(claimElement);
            let dialogRef = this.dialog.open(SubEditClaimchartPopupComponent, {
              data: {
                HTMLData: htmlData,
                claimElement: claimElement,
                index: index
              },
              width: '70vw',
              height: '80%',
              maxWidth: '90vw',
              panelClass: 'custom-dialog-container',
            });
            dialogRef.afterClosed().subscribe((result: any) => {
              if (result) {
                // Update the editableClaimData with the new data from the dialog
                this.handleInfringementBlur({target:result,},index)
                };
              })
            
          
          }
          
          // Generate HTML for claim cell using classnames
          generateClaimHTML(claimElement: any): string {
            return `<div class="claim-item-iterable type-claim">${claimElement.claim_element}</div>`;
          }
          
          // On blur: extract plain claim text from edited HTML
          handleClaimElementBlur(event: FocusEvent, index: number) {
            const container = event.target as HTMLElement;
            const children = Array.from(container.children) as HTMLElement[];
          
            let claimText = '';
            for (const child of children) {
              if (child.classList.contains('type-claim')) {
                claimText += child.innerText.trim() + ' ';
              }
            }
          
            this.editableClaimData[index].claim_element = claimText.trim();
          }
        onSave(): void {
          const processedData = this.editableClaimData.map((item, idx) => ({
            orderKey: item.orderKey ?? idx + 1,
            claim_element: item.claim_element,
            analyst_comment: item.analyst_comment,
            references: item.references.map((ref: any) => ({
              reference: ref.reference,
              source: ref.source
            }))
          }));
          this.dialogRef.close(processedData);
        }
      
        onCancel(): void {
          this.dialogRef.close();
        }

        onChange(e:any){
          console.log('onChange', e);
        }
            
}